import { render, staticRenderFns } from "./InquiryToQesg.vue?vue&type=template&id=41383600&scoped=true&"
import script from "./InquiryToQesg.vue?vue&type=script&lang=js&"
export * from "./InquiryToQesg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41383600",
  null
  
)

export default component.exports